module.exports = __webpack_public_path__ + "static/media/sleep_multiplier_img.cc1c4a2a.svg";